export interface RespostaPaginacao<T> {
  itens: Array<T>
  temProximaPagina: boolean
  quantidade: number
}

export enum TipoDocumentoAluno {
  RegistroCivil = 'RegistroCivil',
  Rg = 'Rg',
  RgVerso = 'RgVerso',
  Rne = 'Rne',
  Cpf = 'Cpf',
  DiplomaGraduacao = 'DiplomaGraduacao',
  DiplomaGraduacaoVerso = 'DiplomaGraduacaoVerso',
  HistoricoEscolar = 'HistoricoEscolar',
  CertidaoNascimento = 'CertidaoNascimento'
}

export enum SituacaoUpload {
  PendenteEnvio = 'PendenteEnvio',
  AguardandoAnalise = 'AguardandoAnalise',
  Aprovado = 'Aprovado',
  Recusado = 'Recusado'
}

export interface ResumoDocumentos {
  documentoId: string
  nomeArquivo: string
  tipo:
    | TipoDocumentoAluno
    | TipoDocumentoProfessor
    | TipoDocumentoResponsavelFinanceiro
  situacaoUpload: SituacaoUpload
  motivoRejeicao: string
  dataPostagem: string
  dataConferencia?: string
  dataNascimento?: string
}

export interface ResumoDocumentosAlunoCertificacao {
  documentoId: string
  nomeArquivo: string
  tipo: TipoDocumentoAlunoCertificacao
  situacaoUpload: SituacaoUpload
  dataUpload: string
  motivoRejeicao?: string
}

export interface ResumoDocumentosProfessorCertificacao {
  documentoId: string
  nomeArquivo: string
  tipo: TipoDocumentoProfessorCertificacao
  situacaoUpload: SituacaoUpload
  dataUpload: string
  motivoRejeicao?: string
}

export interface ResumoDocumentosTurmaCertificacao {
  documentoId: string
  nomeArquivo: string
  tipo: TipoDocumentoTurmaCertificacao
  situacaoUpload: SituacaoUpload
  dataUpload: string
  motivoRejeicao?: string
}

export interface ResumoDocumentosCursoCertificacao {
  documentoId: string
  nomeArquivo: string
  tipo: TipoDocumentoTurmaCertificacao
  situacaoUpload: SituacaoUpload
  dataUpload: string
  motivoRejeicao?: string
}

export interface ResumoDocumentosParceiroCertificacao {
  documentoId: string
  nomeArquivo: string
  tipo: TipoDocumentoTurmaCertificacao
  situacaoUpload: SituacaoUpload
  dataUpload: string
  motivoRejeicao?: string
}

export interface Documento {
  contentType: string
  base64: string
}

export interface DocumentosParaAprovacao {
  documentos: DocumentoParaAprovacao[]
}

export interface DocumentoParaAprovacao {
  documentoId: string
  situacao: SituacaoUpload
  motivoRejeicao: string
}

export interface ResultadoDaAprovacaoDeDocumentos {
  sucesso: boolean
}

export enum TipoDocumentoParceiroCertificacao {
  Logo = 'Logo'
}

export enum TipoDocumentoProfessor {
  RgCnh = 'RgCnh',
  RgCnhVerso = 'RgCnhVerso',
  DiplomaGraduacao = 'DiplomaGraduacao',
  DiplomaGraduacaoVerso = 'DiplomaGraduacaoVerso',
  DiplomaTitulacaoMaxima = 'DiplomaTitulacaoMaxima',
  DiplomaTitulacaoMaximaVerso = 'DiplomaTitulacaoMaximaVerso',
  Rne = 'Rne'
}

export enum TipoDocumentoAlunoCertificacao {
  Rg = 'Rg',
  RgVerso = 'RgVerso',
  DiplomaGraduacao = 'DiplomaGraduacao',
  DiplomaGraduacaoVerso = 'DiplomaGraduacaoVerso'
}

export enum TipoDocumentoTurmaCertificacao {
  PPC = 'PPC'
}

export enum TipoDocumentoCursoCertificacao {
  PPC = 'PPC'
}

export enum TipoDocumentoProfessorCertificacao {
  Rg = 'Rg',
  RgVerso = 'RgVerso',
  Cpf = 'Cpf',
  DiplomaGraduacao = 'DiplomaGraduacao',
  DiplomaGraduacaoVerso = 'DiplomaGraduacaoVerso',
  DiplomaTitulacaoMaxima = 'DiplomaTitulacaoMaxima',
  DiplomaTitulacaoMaximaVerso = 'DiplomaTitulacaoMaximaVerso'
}

export interface ContratoResponsavelFinanceiro {
  usuarioId: string
  arquivo: File | string
}

export enum TipoDocumentoResponsavelFinanceiro {
  Identificacao = 'Identificacao'
}

export interface DataNascimentoDocumento {
  documentoId: string
  dataNascimento: string
}
